<template>
  <v-app>
    <v-main class="login-background">
      <v-container container--fluid fill-height style="margin-bottom:100px;">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12 login-card">
              <v-toolbar class="brand-login-toolbar" height="172" tabs flat>
                <v-spacer></v-spacer>
                <div class="login-logo-wrap">
                  <img :src="logoPrimary" alt="Kobe" />
                </div>
                <v-spacer></v-spacer>
                <v-tabs
                  class="login-tabs"
                  v-model="currentTab"
                  slot="extension"
                  centered
                  slider-color="#3F3FFF"
                  grow
                >
                  <v-tab class="login-tab" href="#login-tab">Login</v-tab>
                  <v-tab class="login-tab" href="#signup-tab" @click="changeTab()">Sign Up</v-tab>
                </v-tabs>
              </v-toolbar>
              <v-card-text class="login-card-text">
                <v-tabs-items v-model="currentTab">
                  <v-tab-item value="login-tab" class="text-center">
                    <v-row class="pt-5" justify="center" align="center">
                      <v-col cols="12" md="8" sm="12" lg="8">
                        <!-- <p class="h3 text-center">
                          For Influencers 
                        </p> -->
                        <!-- <v-btn
                          @click="doTikTokLogin"
                          width="260px"
                          class="white--text ma-1 mb-3"
                          color="black"                        
                        >
                          Continue with TikTok
                        </v-btn> -->
                        <!-- <v-btn
                          @click="doFacebookLogin"
                          width="256px"
                          class="white--text ma-1 mb-2"
                          color="facebook"
                        >
                          <v-icon left color="white" medium>mdi-facebook</v-icon>Continue with Facebook
                        </v-btn> -->
                        <v-btn
                          @click="instagramLogin"
                          width="260px"
                          class="white--text ma-1 mb-2"
                          color="secondary"
                        >
                          <v-icon left color="white" medium>mdi-instagram</v-icon>Login with instagram
                        </v-btn>
                        <!-- <v-btn
                          rounded
                          @click="doGoogleLogin"
                          width="260px"
                          class="white--text ma-1"
                          color="facebook"
                        >
                          Continue with Google
                        </v-btn> -->
                        <!-- <div id="g-signin2">Sign in with Google</div> -->
                        <div class="g-login-container">
                          <div ref="googleLoginBtn"></div>
                        </div>
                        <!-- <v-divider></v-divider> -->
                        <!-- <p class="h3 text-center">
                          For Advertisers <br>
                            <v-btn
                              dark
                              width="260px"
                              class="white--text ma-1"
                              to="client-login"
                            >
                              Go to Client Login
                            </v-btn>
                        </p> -->
                      </v-col>
                    </v-row>
                    <!-- <v-divider></v-divider> -->
                    <v-row justify="center" align="center">
                      <v-col cols="12" xs="12" md="8">
                        <!-- <p class="subtitle"><br> Login using registered email and password.</p> -->
                        <v-form>
                          <v-text-field
                            v-model="email"
                            :error-messages="emailErrors"
                            @blur="$v.email.$touch()"
                            @keydown.space.prevent 
                            @input="removeSpaces" 
                            @paste="preventPasteSpaces" 
                            prepend-icon="person"
                            name="email"
                            label="Email"
                            type="text"
                            width="260px"
                          ></v-text-field>
                          <v-text-field
                            v-model="password"
                            :error-messages="passwordErrors"
                            @input="$v.password.$touch()"
                            @blur="$v.password.$touch()"
                            @keyup.enter="checkCreds()"
                            id="password"
                            prepend-icon="lock"
                            name="password"
                            label="Password"
                            type="password"
                            width="260px"
                          ></v-text-field>
                        </v-form>
                        <v-btn
                          @click="checkCreds()" color="secondary"
                          class="ma-1"
                          rounded
                          width="260px"
                        >Login </v-btn>
                      </v-col>
                    </v-row>
                    <!-- <p class="subheading text-center">Updating our login methods together with Facebook. <a @click="showUpdateDialog = true">See more</a></p> -->
                    <v-row align="center" justify="center">
                      <v-btn text to="/forgot-password" color="secondary">Forgot password?</v-btn>
                      <v-btn text @click="showRegisterTab()" color="secondary">Create New Account</v-btn>
                    </v-row>
                    <v-divider></v-divider>
                    <p class="text-left">
                      By logging in, you confirm that you have read the
                      <a
                        href="https://www.getkobe.com/influencer-terms-use-agreement/"
                        target="_blank"
                      >terms and conditions</a> , that you understand them and that you agree to be bound by them.
                    </p>
                  </v-tab-item>
                  <!-- Sign up tab -->
                  <v-tab-item value="signup-tab">
                    <div class="text-center" style="margin-top:40px;">
                      <!-- <v-chip
                        label
                        outlined
                        color="primary"
                      >Highly recommended to use Instagram registration</v-chip>-->
                      <!-- <p>
                        <b>Kobe</b> doesn't store or use your Instagram passwords.
                        We are securely using
                        <b>Instagram Platform</b> by following the Instagram
                        <a
                          href="https://www.instagram.com/about/legal/terms/api/"
                        >Platform Policy</a>.
                        <br />
                      </p> -->
                      <!-- <a href="#" @click="doFacebookLogin" class="social fa fa-facebook"></a> -->
                      <v-btn
                        @click="doFacebookLogin"
                        width="280px"
                        class="white--text ma-1 mb-2"
                        color="secondary"                        
                      >
                        <v-icon left medium>mdi-facebook</v-icon>Continue with Facebook
                      </v-btn>
                      <v-btn
                        @click="instagramLogin"
                        width="280px"
                        class="white--text ma-1 mb-2"
                        color="secondary"
                      >
                        <v-icon left color="white" medium>mdi-instagram</v-icon>Signup with instagram
                      </v-btn>
                      <!-- <a href="#" @click="instagramLogin" class="social fa fa-instagram"></a> -->
                      <div class="g-login-container">
                        <div ref="googleSignUpBtn"></div>
                      </div>
                      <br />
                    </div>
                    <!-- <p class="subheading text-center mt-2">Or</p>
                    <div class="text-center">
                      <p>
                        Please contact us at
                        <a
                          href="https://mail.google.com/mail/?view=cm&fs=1&to=creator@getkobe.com"
                          target="_blank"
                        >creator@getkobe.com</a> <br>if you want to register with another social platform.
                        <br />
                        <i>Kobe always welcome you to be a part of our family!</i>
                      </p>
                    </div> -->
                    <div class="text-center msg-box">
                      <p>
                        If you require further technical assistance, please refer to this platform <a href="https://drive.google.com/file/d/1aBHRO61bi3Q0XRvDYK-b8VnImvqCBoqz/view" target="_blank">guide</a> or reach out to us at <br/>
                        <a
                          href="https://mail.google.com/mail/?view=cm&fs=1&to=creator@getkobe.com"
                          target="_blank"
                        >creator@getkobe.com</a>
                      </p>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-dialog
          v-model="showUpdateDialog"
          width="500"
        >
          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
            >
              New Updates to Kobe's IMS
            </v-card-title>

            <v-card-text>
              <p>
              <br>
              Kobe's tech team is always on the ball to keep our platform safe, secure, and user-friendly. Unfortunately, sometimes we may need to make changes too.
              Unbeknownst to many, in January 2018, Facebook publicly announced its plans to shut down the Instagram Legacy API platform through a sequenced approach. What this means for us in human language is that we will need to change your login methods very soon. <br>
              And since it's a mandatory change, we will be making a compulsory switch from Instagram Login to Facebook Login method starting from 29th June.
              </p>
              <p>
              Do take note of the following:
              <ol>
              <li>If you are using Email and Password to login to app.getkobe.com, no actions are required. (mainly for our clients)</li>
              <li>If you are using Instagram to login to app.getkobe.com, you will need to re-login with the new Facebook login instead. (Your account will be automatically associated if your Facebook and Instagram account is linked) please ensure your profile switched to either a creator/business profile.</li>
              </ol>
              </p>
              <p>
              For some reasons, if you're stuck, reply to this email and we will help you with the setup! We're here to help make this switch as seamless as possible.
              </p>
              <p>
              Feel free to drop us a message if you have any problems/questions and we hope to see you in our campaign inboxes soon!
              </p>
              <p>
              Love, <br>
              Kobe Fam.
              </p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                text
                @click="showUpdateDialog = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
    <v-footer dark color="#1A1A1A">
      <v-layout row wrap white--text text-center>
        <v-flex md4 xs12>
          <p class="white--text text-center">
            <u>Singapore</u>
            <br />Contact:
            <a href="tel:+6562555662">6255 5662</a> /
            <a href="mailto:creator@getkobe.com">creator@getkobe.com</a>
            <br />51 Goldhill Plaza #14-01 Singapore 308900
          </p>
        </v-flex>
        <v-flex md4 xs12>
          <p class="white--text text-center">
            <br />Website
            <a href="https://getkobe.com/website-terms-use">Terms of Use</a> and
            <a href="https://getkobe.com/website-privacy-policy">Privacy Policy</a>.
            <br />
            All Rights Reserved &copy; 2016-{{year}} Kobe Global Technologies Pte Ltd
          </p>
        </v-flex>
        <v-flex md4 xs12>
          <!-- <p class="white--text text-center">
            <u>Malaysia / Thailand / Indonesia</u>
            <br />Contact:
            <a href="mailto:international@getkobe.com">INTERNATIONAL@GETKOBE.COM</a>
          </p> -->
          <p class="white--text text-center mb-0 pt-2">
            Patent: <a href="https://patentscope.wipo.int/search/en/detail.jsf?docId=SG235183686&_cid=P20-KEI88S-46965-1" target="_blank"> KOBE 11201807777W ℗ </a>
          </p>
        </v-flex>
      </v-layout>
    </v-footer>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="#A3FF12"
      width.number="90"
      height.number="90"
    />
    <div id="g_id_onload"
      :data-client_id="gSigninConfig.CLIENT_ID"
      :data-login_uri="currentDomain"
      data-auto_prompt="false">
    </div>
  </v-app>
</template>

<script>
import api from '@/api';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { regex } from 'vuelidate/lib/validators/common';
import { fbLogin } from '../plugins/fb-sdk';
import apiUrl from '../config/APIs';
import countries from '../../static/sources/countries';
import config from '../config';
import utils from '@/utils'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
const validPassword = regex('validPassword', config.regexPattern.password); // lowercase

export default {
  name: 'Login',
  mixins: [validationMixin],
  components: {
    Loading
  },
  data(router) {
    return {
      year: new Date().getFullYear(),
      section: 'Login',
      loading: false,
      email: '',
      password: '',
      response: '',
      locations: [],
      currentTab: 'login-tab',
      registerUser: {
        firstName: '',
        lastName: '',
        email: '',
        location: '',
        password: '',
        igHandle: '',
        role: 5, // default to Influencer
        activated: 0 // default to NotActivated
      },
      showUpdateDialog: false,
      gSigninConfig: config.gSigninConfig,
      tiktokAuthCode: null,
      logoPrimary: require('@/assets/Kobe Logo Blue.png')
    };
  },
  validations: {
    email: { required, email },
    password: { required },
    registerUser: {
      firstName: { required },
      email: { required, email },
      password: { required, validPassword },
      igHandle: { required }
    }
  },
  methods: {
    doTikTokLogin() {
      this.toggleLoading();
      let loginParams = {
        client_key: 'aw11ehp6bojb6gk3',
        scope: 'user.info.basic',
        response_type: 'code',
        redirect_uri: 'https://uat.app.getkobe.com/login',
        state: Math.random().toString(36).substring(2)
      }
      const query = utils.func.objectToQueryString(loginParams)
      window.location.href = 'https://www.tiktok.com/v2/auth/authorize?' + query;
    },
    async checkTikTokLogin() {
      if (this.$route.query.code) {
        const tiktokRespCode = this.$route.query.code
        let reqParams = {
          client_key: 'aw11ehp6bojb6gk3',
          client_secret: 'UFPaPIOnnMvy2Ool9Acvf8nfvqmvphEh',
          code: tiktokRespCode,
          grant_type: 'authorization_code'
        }
        const query = utils.func.objectToQueryString(reqParams)
        // const response = await api.request('post', 'https://open-api.tiktok.com/oauth/access_token/?' + query, false, {});
        fetch('https://open-api.tiktok.com/oauth/access_token/?' + query, {method: 'post'})
        .then(async (res) => {
          console.log(res.json())
          let resp = res.json()
          let fullName = resp.display_name;
          fullName = fullName.split(' ')
          let data = {
            firstName: fullName[0],
            lastName: fullName.length > 0 ? fullName[1] : '',
            username: resp.username,
            imageUrl: resp.avatar_url
          };
          const response = await api.request('post', '/api/v1/users/tiktok/login/create', false, data);
          if (response.status === 200) {
            let responseData = response.data;
            var userData = responseData ? responseData.user : {};
            var jwtToken = responseData.jwtToken;
            // Remove jwt token from user data
            delete userData.jwtToken;
            /* Setting user in the state and caching record to the localStorage */
            var token = 'Bearer ' + jwtToken;
            this.$store.commit('SET_TOKEN', token);
            this.$store.commit('SET_USER', userData);
            // To-Do -> Fetch notifications data from server and assign here
            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(userData));
              window.localStorage.setItem('token', token);
            }
            this.$router.push({ name: 'Profile' });
          } else {
            console.log('Error', response)
          }
        })
        // console.log(response)
      }
    },
    async onSignIn(user) {
      // Send the signed Google credential as-is; the backend verifies it and
      // derives the account identity from the verified token. Never send a
      // client-chosen email/name — that would be an account-takeover bypass.
      const data = { credential: user.credential };
      const response = await api.request('post', '/api/v1/users/google/basic-display', false, data);
      if (response.status === 200) {
        let responseData = response.data;
        var userData = responseData ? responseData.user : {};
        if (userData.role === config.userRoles.INFLUENCER && !userData.influencerID) {
          this.$router.push({ name: 'RateCardForm',
            query: {
              name: `${userData.firstName} ${userData.lastName}`,
              email: userData.email
            }
          })
          return
        }
        var jwtToken = responseData.jwtToken;
        // Remove jwt token from user data
        delete userData.jwtToken;
        /* Setting user in the state and caching record to the localStorage */
        var token = 'Bearer ' + jwtToken;
        this.$store.commit('SET_TOKEN', token);
        this.$store.commit('SET_USER', userData);
        // To-Do -> Fetch notifications data from server and assign here
        if (window.localStorage) {
          window.localStorage.setItem('user', JSON.stringify(userData));
          window.localStorage.setItem('token', token);
        }
        this.$router.push({ name: 'Profile' });
      } else {
        console.log('Error', response)
      }
    },
    signOut() {
      if (window.gapi.auth2) {
        var auth2 = window.gapi.auth2.getAuthInstance();
        auth2.signOut().then(() => {
          console.log('User signed out');
        });
      }
    },
    initGoogleAuth() {
      // window.gapi.load('auth2', function () {
      //   window.gapi.auth2.init();
      // });
      const gClientId = this.gSigninConfig.CLIENT_ID
      window.google.accounts.id.initialize({
        client_id: gClientId,
        callback: this.onSignIn,
        auto_select: true
      })
      window.google.accounts.id.renderButton(
        this.$refs.googleLoginBtn, {
          text: 'Sign in with', // or 'signup_with' | 'continue_with' | 'signin'
          size: 'large', // or 'small' | 'medium'
          width: '260', // max width 400
          theme: 'outline', // or 'filled_black' |  'filled_blue'
          logo_alignment: 'left' // or 'center'
        }
      )
    },
    // renderGoogleAuthButton() {
    //   window.gapi.signin2.render('g-signin2', {
    //     onsuccess: this.onSignIn
    //   });
    // },
    instagramLogin() {
      this.toggleLoading();
      // window.location.href = process.env.INSTAGRAM_AUTHORIZE_URL || 'http://localhost:8081/api/v1/instagrams/authorize';
      let reqObj = {
        client_id: config.INSTAGRAM_CLIENT_ID,
        redirect_uri: config.INSTAGRAM_LOGIN_REDIRECT_URL,
        scope: 'instagram_business_basic',
        response_type: 'code'
      }
      reqObj = Object.keys(reqObj)
      .map(key => `${key}=${reqObj[key]}`)
      .join('&')
      window.location.href = config.INSTAGRAM_APP_AUTHORIZE_URL + '?' + reqObj
    },
    doFacebookLogin() {
      fbLogin({ scope: config.PERMISSION_SCOPE }).then(response => {
        if (response.status === 'connected') {
          // this.saveInstagramData(response.authResponse);
          this.handlFacebookLogin(response.authResponse);
        }
      });
    },
    async handlFacebookLogin(data) {
      this.toggleLoading();
      /**
       * check fb account alread exist?
       * For new influencer email
       * */
      var isFbSignedUp = false;
      let url = apiUrl.INSTAGRAM_GRAPH_API_CHECK_SESSION_AVAILBLE.replace('{fbId}', data.userID);
      api
        .request('get', url, false)
        .then(response => {
          if (response.status === 200) {
            let data = response.data;
            isFbSignedUp = data.success;
          }
        })
        .catch((err) => console.log('Error', err));
      // ------ end fb account check ----------------------------------------------------------------
      const response = await api.request('post', apiUrl.INSTAGRAM_GRAPH_API_HANDLE_FB_LOGIN, false, data);
      if (response.status === 200) {
        let responseData = response.data;
        if (responseData.shouldRedirect) {
          let data = responseData.data;
          this.$store.commit('SET_FACEBOOK_DATA', JSON.stringify(data));
          this.$router.push({ name: 'FacebookAuth' });
          return;
        }
        var userData = responseData ? responseData.userData : {};
        var jwtToken = responseData.jwtToken;
        // Remove jwt token from user data
        delete userData.jwtToken;
        /* Setting user in the state and caching record to the localStorage */
        var token = 'Bearer ' + jwtToken;
        this.$store.commit('SET_TOKEN', token);
        this.$store.commit('SET_USER', userData);
        // To-Do -> Fetch notifications data from server and assign here
        if (window.localStorage) {
          window.localStorage.setItem('user', JSON.stringify(userData));
          window.localStorage.setItem('token', token);
        }
        // Add noti email here
        if (!isFbSignedUp) {
          var headers = {
            'Authorization': token
          };
          let user = {
            firstName: userData.firstName,
            lastName: userData.lastName,
            igHandle: '#'
          }
          api.request('post', '/api/v1/posts/influencer/notify', false, user, headers);
        }
        this.$router.push({ name: 'Profile' });
      } else {
        console.log('Error', response)
      }
    },
    /**
     * Archived for future use
     */
    saveInstagramData(data) {
      api
        .request('post', apiUrl.INSTAGRAM_GRAPH_API_HANDLE_AUTH, false, data)
        .then(response => {
          if (response.status === 200) {
            let responseData = response.data;
            if (responseData.shouldRedirect) {
              let data = responseData.data;
              this.$store.commit('SET_FACEBOOK_DATA', JSON.stringify(data));
              this.$router.push({ name: 'FacebookAuth' });
              return;
            }
            var userData = responseData ? responseData.userData : {};
            var jwtToken = responseData.jwtToken;
            // Remove jwt token from user data
            delete userData.jwtToken;
            /* Setting user in the state and caching record to the localStorage */
            var token = 'Bearer ' + jwtToken;
            this.$store.commit('SET_USER', userData);
            this.$store.commit('SET_TOKEN', token);
            // To-Do -> Fetch notifications data from server and assign here
            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(userData));
              window.localStorage.setItem('token', token);
            }
            this.$router.push(this.$route.query.redirect ? this.$route.query.redirect : { name: 'Profile' });
          }
        })
        .catch(error => {
          this.$swal({
            title: 'Error',
            text: error.response.data || 'Unexpected error! Please contact us for help',
            type: 'error'
          });
        });
      // window.location.href = process.env.INSTAGRAM_AUTHORIZE_URL || 'http://localhost:8081/api/v1/instagrams/authorize';
    },
    getLocations() {
      this.locations = countries.map(element => element.name);
    },
    checkCreds() {
      let email = this.email
      let password = this.password
      if (email) {
        email = email.toLowerCase()
      }
      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      /* Making API call to authenticate a user */
      api
        .request('post', '/api/v1/users/login', false, { email, password })
        .then(response => {
          this.toggleLoading();

          var userData = response.data;
          var jwtToken = userData.jwtToken;

          // Remove jwt token from user data
          delete userData.jwtToken;

          /* Setting user in the state and caching record to the localStorage */
          var token = 'Bearer ' + jwtToken;

          this.$store.commit('SET_USER', userData);
          this.$store.commit('SET_TOKEN', token);
          // To-Do -> Fetch notifications data from server and assign here
          if (window.localStorage) {
            window.localStorage.setItem('user', JSON.stringify(userData));
            window.localStorage.setItem('token', token);
          }

          if (userData.role === config.userRoles.AD_STRATEGIST) {
            this.$router.push({name: 'co-dashboard'})
          } else if (userData.role === config.userRoles.ACCOUNT_MANAGER) {
            this.$router.push({name: 'am-dashboard'})
          } else {
            this.$router.push(this.$route.query.redirect ? this.$route.query.redirect : '/Profile');
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING');
          // Show error alert
          // if no data in response, show the default error message
          this.$swal({
            title: 'Error',
            text: error.response.data.err || 'Please enter your Username & Password correctly! (or) Contact us for help',
            type: 'error'
          });

          this.response = error;
          this.toggleLoading();
        });
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    resetResponse() {
      this.response = '';
    },
    registerInfluencer() {
      // to-do implement registration for Influencer
      this.toggleLoading();
      const user = Object.assign({}, this.registerUser);

      // Add user
      api
        .request('post', '/api/v1/users/register', false, user)
        .then(response => {
          this.toggleLoading();
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'Your account is registered!, Please check your email and click on activation link to activate the account',
            type: 'success'
          });
        })
        .catch(error => {
          this.toggleLoading();
          console.log('Error: ' + error);
          // Show error message
          this.$swal({
            title: 'Sorry',
            text: error.response.data.message || 'Something went wrong! Please try again! (or) Contact Us for Help',
            type: 'error'
          });
        });
    },
    showRegisterTab() {
      this.currentTab = 'signup-tab'
    },
    decodeJwtResponseFromGoogleAPI(token) {
      let base64Url = token.split('.')[1]
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload)
    },
    changeTab() {
      setTimeout(() => {
        window.google.accounts.id.renderButton(
          this.$refs.googleSignUpBtn, {
            text: 'signup_with', // or 'signup_with' | 'continue_with' | 'signin'
            size: 'large', // or 'small' | 'medium'
            width: '280', // max width 400
            theme: 'outline', // or 'filled_black' |  'filled_blue'
            logo_alignment: 'left' // or 'center'
          }
        )
      }, 1000)
    },
    // Remove spaces after input (to clear spaces if pasted somehow)
    removeSpaces() {
      this.$v.email.$touch()
      this.email = this.email.replace(/\s/g, '');
    },
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    }
  },
  mounted: function() {
    let status = this.$route.query.redirect;
    this.$nextTick(function() {
      if (status === 'activated') {
        this.$swal({
          title: 'Success',
          text: 'Activation Success! You may login now.',
          type: 'success'
        });
      } else if (status === 'failed') {
        this.$swal({
          title: 'Failed',
          text: 'Activation Failed! Please contact our Support or Try Again',
          type: 'error'
        });
      } else if (status === 'alreadyConfirmed') {
        this.$swal({
          title: 'Error',
          text: 'Your Account is already activated',
          type: 'error'
        });
      } else if (status === 'noUser') {
        this.$swal({
          title: 'Error',
          text: 'No User account found, please contact Support',
          type: 'error'
        });
      } else if (status === 'session_ended') {
        this.$swal({
          title: 'Warning',
          text: 'Your session has ended. Please login again',
          type: 'warning'
        });
      }
    });
    this.getLocations();
    // this.signOut();
    setTimeout(() => {
      this.initGoogleAuth();
    }, 1000)
    if (this.$route.query.code) {
      this.checkTikTokLogin()
    }
  },
  computed: {
    currentDomain() {
      if (location.hostname === 'localhost') {
        return location.protocol + '//' + location.hostname + ':' + location.port
      }
      return location.protocol + '//' + location.hostname
    },
    // Form Validation Errors
    nameErrors() {
      const errors = [];
      if (!this.$v.registerUser.firstName.$dirty) return errors;
      !this.$v.registerUser.firstName.required && errors.push('FirstName is required');
      return errors;
    },
    registerEmailErrors() {
      const errors = [];
      if (!this.$v.registerUser.email.$dirty) return errors;
      !this.$v.registerUser.email.email && errors.push('Must be valid e-mail');
      !this.$v.registerUser.email.required && errors.push('E-mail is required');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    registerPasswordErrors() {
      const errors = [];
      if (!this.$v.registerUser.password.$dirty) return errors;
      !this.$v.registerUser.password.required && errors.push('Password is required');
      !this.$v.registerUser.password.validPassword &&
        errors.push('Password must contain number, uppercase, lowercase, special symbols and more than 8 characters.');
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    },
    igHandleErrors() {
      const errors = [];
      if (!this.$v.registerUser.igHandle.$dirty) return errors;
      !this.$v.registerUser.igHandle.required && errors.push('Instagram account name is required');
      return errors;
    }
  }
};
</script>

<style scoped>
.v-footer {
  padding-top: 50px;
  padding-bottom: 50px;
  height: 'auto';
}

.login-background {
  background:
    radial-gradient(circle at top left, rgba(163, 255, 18, 0.28), transparent 34%),
    radial-gradient(circle at top right, rgba(106, 13, 173, 0.26), transparent 30%),
    radial-gradient(circle at bottom right, rgba(63, 63, 255, 0.24), transparent 32%),
    linear-gradient(-45deg, #1a1a1a, #3f3fff, #6a0dad, #a3ff12);
  background-size: 100% 100%, 100% 100%, 100% 100%, 400% 400%;
  animation: gradient 16s ease infinite;
}

.login-card {
  overflow: hidden;
  border: 1px solid rgba(63, 63, 255, 0.16);
  border-radius: 24px !important;
  box-shadow: 0 22px 64px rgba(26, 26, 26, 0.28) !important;
}

.brand-login-toolbar {
  background: #a3ff12 !important;
  border-bottom: 1px solid rgba(63, 63, 255, 0.18);
  padding-top: 14px;
}

.brand-login-toolbar::v-deep .v-toolbar__content,
.brand-login-toolbar::v-deep .v-toolbar__extension {
  background: #a3ff12 !important;
}

.login-logo-wrap {
  background: #a3ff12;
  width: min(260px, 72vw);
  max-width: 260px;
  line-height: 0;
}

.login-logo-wrap img {
  display: block;
  width: 100%;
  height: auto;
}

.login-tabs {
  background-color: #a3ff12;
}

.login-card-text {
  padding-top: 24px;
}

.login-primary-btn {
  color: #1a1a1a !important;
  font-weight: 700;
}

.login-tab {
  color: #3f3fff !important;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.login-tabs ::v-deep .v-tabs-bar {
  background-color: #a3ff12 !important;
}

.login-tabs ::v-deep .v-tab {
  color: #3f3fff !important;
  opacity: 0.68;
}

.login-tabs ::v-deep .v-tab.v-tab--active {
  color: #3f3fff !important;
  opacity: 1;
}

.login-tabs ::v-deep .v-tabs-slider-wrapper {
  height: 4px !important;
}

@keyframes gradient {
  0% {
    background-position: 0% 0%, 100% 0%, 100% 100%, 0% 50%;
  }
  50% {
    background-position: 0% 0%, 100% 0%, 100% 100%, 100% 50%;
  }
  100% {
    background-position: 0% 0%, 100% 0%, 100% 100%, 0% 50%;
  }
}

.msg-box {
  margin-top: 20px;
  max-width: 350px;
  margin-left: auto;
  margin-right: auto;
}

.g-login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// Login.vue?0d109cf3